import AssessmentDetail from './AssessmentDetail';

export default AssessmentDetail;
